var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartOne"},[_c('h4'),_c('div',{staticClass:"codMain",attrs:{"id":_vm.codMain}})])}
var staticRenderFns = []

export { render, staticRenderFns }